import { FC } from 'react';
import './desktopGetTheAppPopup.scss';
import { parsePhoneNumber } from 'libphonenumber-js';

import Popup from 'components/popup/Popup';
import { translations } from 'translations/en';
import { Image } from 'components/helpers';
import manHoldingPhone from 'photos/manholdingmobile.png';
import GetTheAppButtons from '../../GetTheAppButtons';
import GetTheAppPhoneForm from './GetTheAppPhoneForm';

export interface IDesktopGetTheAppPopup {
  isSuccess: boolean;
  onHide(): void;
  onPhoneSubmit(input: { phone: string }): void;
  serverErrorMessage?: string;
}

const DesktopGetTheAppPopup: FC<IDesktopGetTheAppPopup> = ({
  isSuccess,
  onHide,
  onPhoneSubmit,
  serverErrorMessage,
}) => {
  const phoneSubmit = (input: { phone: string }) => {
    const phoneToSend = parsePhoneNumber(input.phone).number;
    onPhoneSubmit({ phone: phoneToSend });
  };

  return (
    <Popup hide={onHide} withOverlay className="get-the-app-popup">
      <Popup.Content>
        <div className="get-the-app-form">
          <span className="title">{translations.GET_THE_APP.DOWNLOAD_APP}</span>
          <span className="description">{translations.GET_THE_APP.DESCRIPTION}</span>
          {!isSuccess && (
            <GetTheAppPhoneForm errorMessage={serverErrorMessage} onPhoneSubmit={phoneSubmit} />
          )}
          {isSuccess && (
            <span className="link-sent-message">{translations.GET_THE_APP.LINK_SENT}</span>
          )}
          <div className="form-footer">
            <span className="footer-text">{translations.GET_THE_APP.SEARCH_TEDOOO}</span>
            <div className="buttons-container">
              <GetTheAppButtons />
            </div>
          </div>
        </div>
        <Image src={manHoldingPhone} className="popup-main-image" />
      </Popup.Content>
    </Popup>
  );
};

export default DesktopGetTheAppPopup;
